import { render, staticRenderFns } from "./Datepicker.vue?vue&type=template&id=980840d8"
import script from "./Datepicker.vue?vue&type=script&lang=js"
export * from "./Datepicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports